module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BHFXkb/tc-custom/9781439677711.jpg?1704887003468",
      "alt": "This image is the cover for the book Rise of Napa Valley Wineries, The, American Palate"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rise of Napa Valley Wineries, The, American Palate\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A wine country odyssey. "), _c('br'), _vm._v(" In 1976, the picturesque, agrarian Napa Valley was all but unknown to those who didn't live there. That changed dramatically when Steven Spurrier and Patricia Gallagher decided to host a blind tasting of American and French wines in Paris. When wines from California defeated those of France, the world was shocked, an industry reawakened, and Napa Valley exploded in a frenzy of growth and development. Families who had farmed for generations battled to hang onto their land, and many paid a steep price as the area transformed into one of the world's premier wine-growing regions. "), _c('br'), _vm._v(" Join author Mark Gudgel as he explores the trials and tribulations of Napa's meteoric rise to prominence.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Gudgel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dr. Mark Gudgel is a father, husband, college professor, marathon runner and author. A regular contributor to Edible Marin & Wine Country and Napa Valley Life , his previous book, Think Higher Feel Deeper , focused on his career in Holocaust education. He is the board president of the vinNEBRASKA Foundation and currently working on a book about the Court of Master Sommeliers and a travel guide to the Napa Valley. Gudgel lives in Omaha with his wife, Sonja, and their children, Zooey and Titus.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0